import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './badge.module.scss';

export interface BadgeProps {
    text: string | JSX.Element;
    isInsideCard?: boolean;
}

export const BadgeWrapper: React.FC<PropsWithChildren> & React.HTMLAttributes<HTMLDivElement> = ({
    children,
    ...attributes
}) => {
    return (
        <div className={styles.badgeWrapper} {...attributes}>
            {children}
        </div>
    );
};

const Badge: React.FC<BadgeProps> & React.HTMLAttributes<HTMLDivElement> = ({ text, isInsideCard, ...attributes }) => {
    return (
        <span className={classNames(styles.badge, { '-inside-serp-card': isInsideCard })} {...attributes}>
            {text}
        </span>
    );
};

export default Badge;
